import Space from "antd/lib/space";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Checkbox from "antd/lib/checkbox";
import Radio from "antd/lib/radio";
import Form, { RuleObject } from "antd/lib/form";
import React, { MutableRefObject } from "react";
import styled from "styled-components";

import { AppCard } from "components/card";
import { Colors } from "helpers/colors";
import { SurveyInput } from "pages/symptoms/surveyForms/surveyInput";
import { Platform } from "constants/roles";
interface KidneyStoneSectionProps {
  readonly currentPage: number;
  setOtherKidneyStoneLastExperienceTempInput(input: string): void;
  readonly otherKidneyStoneLastExperienceTempInput: string;
  readonly otherKidneyStoneLastExperienceTempInputRef: MutableRefObject<string>;
  readonly otherDurationKnownAboutKidneyStoneTempInput: string;
  setOtherDurationKnownAboutKidneyStoneTempInput(input: string): void;
  readonly otherDurationKnownAboutTempInputRef: MutableRefObject<string>;
  setShowSubmit(show: boolean): void;
}

export const KidneyStoneSection: React.FC<KidneyStoneSectionProps> = ({
  currentPage,
  otherKidneyStoneLastExperienceTempInputRef,
  otherKidneyStoneLastExperienceTempInput,
  setOtherKidneyStoneLastExperienceTempInput,
  otherDurationKnownAboutKidneyStoneTempInput,
  setOtherDurationKnownAboutKidneyStoneTempInput,
  otherDurationKnownAboutTempInputRef,
  setShowSubmit
}) => {
  const params = new URLSearchParams(window.location.search);
  const platform = params.get("platform");
  const validateLastExperienceOfKidneyStone = (
    rules: RuleObject,
    value: string,
    callback: (error?: string) => void
  ) => {
    if (
      otherKidneyStoneLastExperienceTempInputRef.current === "" &&
      localStorage.getItem("lastExperienceOfKidneyStones")?.includes("Other")
    ) {
      callback("Please enter value for 'Other' field.");
    } else {
      callback();
    }
  };

  const validateDurationKnownOfKidneyStone = (
    rules: RuleObject,
    value: string,
    callback: (error?: string) => void
  ) => {
    if (
      otherDurationKnownAboutTempInputRef.current === "" &&
      localStorage.getItem("durationKnownAboutYourKidney")?.includes("Other")
    ) {
      callback("Please enter value for 'Other' field.");
    } else {
      callback();
    }
  };

  return (
    <>
      {currentPage === 7 && (
        <Space direction="vertical" size={20}>
          <Space direction="vertical" size={20}>
            <AppCard
              cardHeight="fit-content"
              cardWidth={
                platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
              }
            >
              <Space
                direction="vertical"
                size={20}
                style={{ width: "100%", padding: "10px" }}
              >
                <DisclaimerTitle>Kidney Stone</DisclaimerTitle>
                <CardTitle>
                  Have you ever had a kidney stone?
                  <AsteriskStyle> *</AsteriskStyle>
                </CardTitle>
                <FormItemStyle
                  name="Have you ever had a kidney stone"
                  label=""
                  rules={[
                    {
                      required: true
                    }
                  ]}
                  initialValue={""}
                >
                  <Radio.Group
                    value={localStorage.getItem("hadAKidneyStone")}
                    onChange={e => {
                      if (e.target.value === "No") {
                        setShowSubmit(true);
                      } else {
                        setShowSubmit(false);
                      }
                      localStorage.setItem("hadAKidneyStone", e.target.value);
                    }}
                  >
                    <Space direction="vertical">
                      <Radio value={"Yes"}>Yes</Radio>
                      <Radio value={"No"}>No</Radio>
                    </Space>
                  </Radio.Group>
                </FormItemStyle>
              </Space>
            </AppCard>
          </Space>
        </Space>
      )}
      {currentPage === 8 && (
        <Space direction="vertical" size={20}>
          <AppCard
            cardHeight="fit-content"
            cardWidth={
              platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
            }
          >
            <Space
              direction="vertical"
              size={20}
              style={{ width: "100%", padding: "10px" }}
            >
              <DisclaimerTitle>Kidney Stone Symptoms</DisclaimerTitle>
              <CardTitle>
                When did you last experience symptoms from your kidney stone?
                <AsteriskStyle> *</AsteriskStyle>
              </CardTitle>

              <FormItemStyle
                name="Last experience of symptoms"
                label=""
                initialValue={""}
                rules={[
                  {
                    required: true
                  },
                  {
                    validator: validateLastExperienceOfKidneyStone,
                    validateTrigger: "submit"
                  }
                ]}
              >
                <Checkbox.Group
                  style={{ width: "100%" }}
                  onChange={e =>
                    localStorage.setItem(
                      "lastExperienceOfKidneyStones",
                      e.toString()
                    )
                  }
                  value={sessionStorage
                    .getItem("lastExperienceOfKidneyStones")
                    ?.split(/,/)}
                >
                  <Row gutter={[10, 10]}>
                    <Col span={24}>
                      <Checkbox value="In the last 2 weeks">
                        In the last 2 weeks
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="In the last 3 months">
                        In the last 3 months
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="In the last 3 - 6 months">
                        In the last 3 - 6 months
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="In the last 6 - 12 months">
                        In the last 6 - 12 months
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="More than 1 year ago">
                        More than 1 year ago
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Other">Other</Checkbox>
                      <SurveyInput
                        value={
                          otherKidneyStoneLastExperienceTempInput ??
                          otherKidneyStoneLastExperienceTempInputRef
                        }
                        placeholder={""}
                        onChange={e => {
                          setOtherKidneyStoneLastExperienceTempInput(
                            e.target.value
                          );
                          otherKidneyStoneLastExperienceTempInputRef.current =
                            e.target.value;
                        }}
                        style={{ width: "70%", marginLeft: "30px" }}
                      />
                    </Col>
                  </Row>
                </Checkbox.Group>
              </FormItemStyle>
            </Space>
          </AppCard>
        </Space>
      )}
      {currentPage === 9 && (
        <Space direction="vertical" size={20}>
          <AppCard
            cardHeight="fit-content"
            cardWidth={
              platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
            }
          >
            <Space
              direction="vertical"
              size={20}
              style={{ width: "100%", padding: "10px" }}
            >
              <DisclaimerTitle>Duration of Kidney Stone</DisclaimerTitle>
              <CardTitle>
                How long have you known about your kidney stone?
                <AsteriskStyle> *</AsteriskStyle>
              </CardTitle>

              <FormItemStyle
                name="How long have you known about your kidney stone"
                label=""
                initialValue={""}
                rules={[
                  {
                    required: true
                  },
                  {
                    validator: validateDurationKnownOfKidneyStone,
                    validateTrigger: "submit"
                  }
                ]}
              >
                <Checkbox.Group
                  style={{ width: "100%" }}
                  onChange={e =>
                    localStorage.setItem(
                      "durationKnownAboutYourKidney",
                      e.toString()
                    )
                  }
                  value={sessionStorage
                    .getItem("durationKnownAboutYourKidney")
                    ?.split(/,/)}
                >
                  <Row gutter={[10, 10]}>
                    <Col span={24}>
                      <Checkbox value="2 weeks">2 weeks</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="3 months">3 months</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="4 - 6 months">4 - 6 months</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="More than 1 year">
                        More than 1 year
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Other">Other</Checkbox>
                      <SurveyInput
                        value={
                          otherDurationKnownAboutKidneyStoneTempInput ??
                          otherDurationKnownAboutTempInputRef
                        }
                        placeholder={""}
                        onChange={e => {
                          setOtherDurationKnownAboutKidneyStoneTempInput(
                            e.target.value
                          );
                          otherDurationKnownAboutTempInputRef.current =
                            e.target.value;
                        }}
                        style={{ width: "70%", marginLeft: "30px" }}
                      />
                    </Col>
                  </Row>
                </Checkbox.Group>
              </FormItemStyle>
            </Space>
          </AppCard>
        </Space>
      )}
    </>
  );
};

const DisclaimerTitle = styled.div`
  width: 100%;
  padding: 8px 8px 8px 20px;
  margin-left: -25px;
  background: ${Colors.DodgerBlue};
  font-size: 18px;
  font-family: sans-serif;
  border-radius: 8px 8px 0px 0px;
  color: white;
  position: absolute;
  top: 0;
`;

const FormItemStyle = styled(Form.Item)`
  margin-bottom: 0px;
`;

const AsteriskStyle = styled.span`
  font-weight: 800;
  color: red;
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-family: sans-serif;
`;
